export default __webpack_public_path__ + "static/media/loved.29eaf5a5.svg";